"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7923],{

/***/ 67923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(965);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);




var AmplitudeAnalytics = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((0,_helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_2__/* .isFeatureEnabled */ .cr)("isAmplitudeEnabled")) {
            var ref, ref1;
            window === null || window === void 0 ? void 0 : (ref = window.amplitude) === null || ref === void 0 ? void 0 : ref.add(window.sessionReplay.plugin({
                sampleRate: 1
            }));
            window === null || window === void 0 ? void 0 : (ref1 = window.amplitude) === null || ref1 === void 0 ? void 0 : ref1.init(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__.AMPLITUDE_API_KEY, {
                autocapture: {
                    fileDownloads: false
                }
            });
        }
    }, []);
    if (!(0,_helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_2__/* .isFeatureEnabled */ .cr)("isAmplitudeEnabled")) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz",
                as: "script"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz",
                as: "script"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "amplitude-analytics",
                src: "https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "amplitude-session-replay",
                src: "https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AmplitudeAnalytics);


/***/ })

}]);